<template>
  <div class="main-content">
    <div class="container pt-150">
      <!-- Section Content -->
      <div class="section-content">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-theme-colored text-center">Reset password</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Divider: Contact -->
    <section class="divider">
      <div class="container">
        <div class="row">
          <div
            class="col-md-8 col-md-offset-2 pl-20 pr-20"
            v-if="!this.PassToken"
          >
            <div v-if="successReset">
              <h3 class="mt-0 mb-10 text-center">
                Mail di reset inviata correttamente
              </h3>
            </div>

            <div v-if="!successReset">
              <h3 class="mt-0 mb-10 text-center">Inserisci la tua mail</h3>
              <!-- Insert mail  -->
              <form @submit="clickLogin">
                <div class="row">
                  <div class="form-group">
                    <label>Email</label>
                    <input
                      type="text"
                      v-model="getPassForm.email"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="form-group text-center pt-10">
                  <button
                    type="submit"
                    class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white"
                  >
                    Recupera password
                  </button>
                  <p
                    v-if="failed"
                    class="text-theme-colored font-12 font-weight-400 pt-10"
                  >
                    Account non trovato, ti preghiamo di riprovare
                  </p>
                </div>
              </form>
            </div>
          </div>

          <div
            class="col-md-8 col-md-offset-2 pl-20 pr-20"
            v-if="this.PassToken"
          >
            <h3 class="mt-0 mb-10 text-center">
              Inserisci la tua nuova password
              <form @submit="setNewPass">
                <div class="row mt-20">
                  <div class="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      v-model="resetPassForm.newPassword"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Conferma password</label>
                    <input
                      type="password"
                      v-model="resetPassForm.newPasswordConfirm"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="form-group text-center pt-10">
                  <button
                    type="submit"
                    class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white"
                  >
                    Imposta password
                  </button>
                  <p
                    v-if="resetPassForm.notCorrectLength"
                    class="text-theme-colored font-12 font-weight-400 pt-10"
                  >La password deve avere una complessità di almeno 8 caratteri</p>
                  <p
                    v-if="resetPassForm.notSamePass"
                    class="text-theme-colored font-12 font-weight-400 pt-10"
                  >Le password non sono uguali</p>
                  <p
                    v-if="failed"
                    class="text-theme-colored font-12 font-weight-400 pt-10"
                  >
                    Account non trovato, ti preghiamo di riprovare
                  </p>
                </div>
              </form>
            </h3>

            <!-- Nuova password- Conferma Password -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
  
  <style scoped>
#contact_form.was-validated .form-control:invalid {
  border-color: #ee163b;
}

.vertical-center {
  top: 50%;
  position: absolute;
}

@media (min-width: 768px) {
  .row.equal {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
     
  <script>
import axios from "axios";

export default {
  name: "ResetPassword",
  props: ["PassToken"],
  data() {
    return {
      failed: false,
      successReset: false,
      getPassForm: {
        email: "",
      },
      resetPassForm: {
        newPassword: "",
        newPasswordConfirm: "",
        notSamePass: false,
        notCorrectLength: false,
      },
      Contact: {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
      },
    };
  },
  methods: {
    setNewPass: function (e) {
      e.preventDefault();

      if(this.resetPassForm.newPassword != this.resetPassForm.newPasswordConfirm)
      {
        this.resetPassForm.notSamePass = true;
        return;
      }

      if(this.resetPassForm.newPassword.length < 8)
      {
        this.resetPassForm.notCorrectLength = true;
        return;
      }


      const objForLogin = {
          resetPasswordToken: this.PassToken,
          newPassword: this.resetPassForm.newPassword,
        };

        axios
          .post(process.env.VUE_APP_API_URL + "/user/changepass", objForLogin)
          .then((response) => {
            if(response.data.ok == true){
              window.location.replace("/login");
            }
          })
          .catch((err) => {
            console.log(err);
            this.failed = true;
          });
    },
    clickLogin: function (e) {
      e.preventDefault();
      if (this.getPassForm.email != "") {
        const objForLogin = {
          email: this.getPassForm.email.toLowerCase().trim(),
        };

        axios
          .post(process.env.VUE_APP_API_URL + "/user/resetpass", objForLogin)
          .then((response) => {
            if(response.data.ok == true){
              this.successReset = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.failed = true;
          });
      }
    },
  },
  mounted: () => {
    var form = document.getElementById("contact_form");
    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>